<template>
  <div class="mask-container">
    <img class="mask-img" src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/d4227d39f7064732be2798879fcc2c0b.png"/>
    <div class="query-input">
      <el-input class="search-input" type="textarea" resize="none" :rows="3" placeholder="提出你的问题，探索医学知识的世界" :input-style="inputStyle" v-model="inputQuery" />
      <div class="bottom-btn">
          <div class="label">
            <img src="https://image.zhihuishu.com/zhs/b2cm/base1/202508/04b93798b7f941fb8d9c0a7b082a394f.png"/>
          </div>
          <div class="send-btn" :class="{ 'active': inputQuery.length>0 }" @click="handleSend">
            <img src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202507/438d908298824cd895d2e6330e4375ad.png" alt="send-icon"  />
          </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';

const inputStyle = {
    background: 'transparent',
    border: 'none'
};

const inputQuery = ref('');


// 发送
const handleSend = () => {
    if (!inputQuery.value) return;
    window.open('https://platform.polymas.com/aiTalk.html?question=' + inputQuery.value);
};
</script>

<style lang="scss" scoped>
.mask-img {
  position: absolute;
  bottom: 400px;
  left: 50%;
  transform: translateX(-50%);
  width: 761px;
  height: 192px;
} 
.query-input {
    width: 720px;
    min-height: 124px;
    padding: 16px 0 12px 16px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    background-color: rgba(255, 255, 255, 0.4);
    backdrop-filter: blur(20px);
    border-radius: 12px;
    flex-shrink: 0;
    margin-top: 85px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    box-sizing: border-box;
    .el-textarea {
        outline: 0;
        box-sizing: border-box;
        :deep(.el-textarea__inner) {
            background-color: transparent;
            box-shadow: 0 0 0 0 transparent;
            padding: 0;
            border: none;
            color: #fff;
            // caret-color: var(--color-primary-red);
        }
        :deep(.el-textarea__inner::placeholder) {
            color: rgba(255, 255, 255, 0.6);
            font-family: 'PingFang SC';
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }

        :deep(.el-textarea__inner::-webkit-scrollbar) {
            width: 4px;
            height: 46px;
        }
        :deep(.el-textarea__inner::-webkit-scrollbar-thumb) {
            border-radius: 90px;
            background: #e5e6eb;
        }
    }
    .bottom-btn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 16px;
        .label {
            img {
                width: 64px;
                height: 25px;
            }
        }
        .send-btn {
            width: 30px;
            height: 30px;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
                width: 16px;
                height: 16px;
            }
            &.active {
                border-radius: 8px;
                background: rgba(67, 40, 133, 0.50);
            }
            &:hover {
                cursor: pointer;
            }
        }
    }
}
</style>